import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    modal_container: {
        minWidth: '300px',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'center',
        backgroundColor: theme.palette.common.white,
        borderRadius: '4px',
        padding: '16px',
        border: `1px solid ${theme.palette.grey[200]}`,
        "@media (max-width: 800px)": {
            position: 'absolute',
            top: '10vh'
        }
    },
    input: {
        marginTop: '16px'
    },
    cancel_btn: {
        marginTop: '16px',
        marginLeft: '10px'
    },
    btn_container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'right',
        width: '100%'
    },
    custom_button_container: {
        display: 'flex'
    },
    display_flex: {
        display: 'flex',
        gap: '8px',
        "@media (max-width: 800px)": {
            flexDirection: "column"
        }
    },
    flex_1: {
        flex: '1'
    }
}));

export {useStyles}